// extracted by mini-css-extract-plugin
export default {"loader_wrapper":"VirtualNumbers_loader_wrapper__oAF1y","dangerButton":"VirtualNumbers_dangerButton__MyAUF"};